import React, { useState } from 'react'
import { Link } from '@inertiajs/react'
import { Drawer } from '@material-tailwind/react'

import Logo from '@/Shared/Logo'
import MainMenu from '@/Shared/MainMenu'

export default () => {
  const [menuOpened, setMenuOpened] = useState(false)

  return (
    <div className="flex items-center justify-between bg-indigo-900 px-6 py-4 md:w-64 md:flex-shrink-0 md:justify-center">
      <Link className="mt-1" href="/">
        <Logo className="fill-current text-white" width="120" height="28" />
      </Link>
      <div className="relative md:hidden">
        <svg
          onClick={() => setMenuOpened(true)}
          className="h-6 w-6 cursor-pointer fill-current text-white"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
        </svg>
      </div>

      <Drawer open={menuOpened} onClose={() => setMenuOpened(false)}>
        <MainMenu className="h-full w-full overflow-y-auto !rounded-none" />
      </Drawer>
    </div>
  )
}
